import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import SettingsInfoNotice from './SettingsInfoNotice';

export default function SettingsModuleRedirect({
  icon: ModuleIcon,
  title,
  description,
  linkTo,
  linkLabel,
  bullets = [],
  noticeTitle,
  noticeBody,
}) {
  return (
    <div className="space-y-6">
      <SettingsInfoNotice variant="info" title={noticeTitle}>
        <p>{noticeBody}</p>
      </SettingsInfoNotice>

      <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-soft dark:border-slate-700 dark:bg-slate-900/75 sm:p-8">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-start">
          {ModuleIcon ? (
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-forma-100 text-forma-600 dark:bg-forma-900/40 dark:text-forma-300">
              <ModuleIcon className="h-6 w-6" />
            </div>
          ) : null}
          <div className="min-w-0 flex-1 space-y-4">
            <div>
              <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-50">{title}</h3>
              <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">{description}</p>
            </div>

            {bullets.length > 0 ? (
              <ul className="list-inside list-disc space-y-1 text-sm text-slate-600 dark:text-slate-400">
                {bullets.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            ) : null}

            <Link
              to={linkTo}
              className="inline-flex items-center gap-2 rounded-xl bg-forma-600 px-4 py-2.5 text-sm font-medium text-white shadow-md transition hover:bg-forma-500"
            >
              {linkLabel}
              <ArrowTopRightOnSquareIcon className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
